<template>
    <div class="orb-business-panel">

    <div  class="border">
      <div class="header">
        <div class="header-text">
          <div class="pt-kicker">业务面板</div>
          <p class="card-title">{{ title }}</p>
        </div>
        <button class="close" @click="closeClick">&times;</button>
      </div>

      <div class="table-content">
        <table class="table">
          <tr>
            <td>指标类别</td>
            <td>具体指标</td>
            <td>西线生效后(远期推荐方案)</td>
            <td>西线生效前-方案一(近期推荐方案)</td>
            <td>西线生效前-方案二(比较方案)</td>
            <td>西线生效前-方案三(比较方案)</td>
            <td>备注/说明</td>
          </tr>
          <tr>
            <td rowspan="4">核心供水指标</td>
            <td>供水规模(亿m)</td>
            <td>18.59</td>
            <td>10.32</td>
            <td>10.32</td>
            <td>10.32</td>
            <td>方案三供水规模与方案一同</td>
          </tr>
          <tr>
            <td>增加供水量(亿m2)</td>
            <td>12.04</td>
            <td>4.95</td>
            <td>458</td>
            <td>451</td>
            <td></td>
          </tr>
          <tr>
            <td>指标缺口(亿m)</td>
            <td>0</td>
            <td>2.57</td>
            <td>231</td>
            <td>0</td>
            <td></td>
          </tr>
          <tr>
            <td>是否新增灌溉面积</td>
            <td>新增</td>
            <td>最大范围新增</td>
            <td>部分新增</td>
            <td>不新增</td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="4">供水对象与水量</td>
            <td>城市及县城水量(亿m)</td>
            <td>163</td>
            <td>152</td>
            <td>163</td>
            <td>140</td>
            <td>覆盖9个县市区域</td>
          </tr>
          <tr>
            <td>工业园区水量(亿m2)</td>
            <td>155</td>
            <td>155</td>
            <td>155</td>
            <td>094</td>
            <td>覆盖12个工业园区</td>
          </tr>
          <tr>
            <td>农村生活水量(亿m2)</td>
            <td>051</td>
            <td>0.42</td>
            <td>042</td>
            <td>无</td>
            <td></td>
          </tr>
          <tr>
            <td>农业灌溉水量(亿m2)</td>
            <td>14.90</td>
            <td>684</td>
            <td>672</td>
            <td>798</td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="4">量溉面积(万亩)</td>
            <td>总灌溉面积</td>
            <td>578.65</td>
            <td>355.75</td>
            <td>316.05</td>
            <td>339.70</td>
            <td></td>
          </tr>
          <tr>
            <td>-替代现有灌区面积</td>
            <td>213.82</td>
            <td>195.52</td>
            <td>195.52</td>
            <td>195.52</td>
            <td>东雷一/二级、禹门口等</td>
          </tr>
          <tr>
            <td>-补充现有灌区面积</td>
            <td>216.55</td>
            <td>31.00</td>
            <td>49.20</td>
            <td>144.16</td>
            <td>交口、洛惠渠等</td>
          </tr>
          <tr>
            <td>-新增灌溉面积</td>
            <td>148.28</td>
            <td>129.23</td>
            <td>73.29</td>
            <td>0</td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="3">工程布局与投资</td>
            <td>总工程投资(亿元)</td>
            <td>557.79</td>
            <td>503.00</td>
            <td>489.30</td>
            <td>417.48</td>
            <td></td>
          </tr>
          <tr>
            <td>线路总长度</td>
            <td>1124.3</td>
            <td>942.6</td>
            <td>848.6</td>
            <td>683.9</td>
            <td>含干洞、管道等</td>
          </tr>
          <tr>
            <td>取水流量(m2/s)</td>
            <td>160.0</td>
            <td>95.6</td>
            <td>89.0</td>
            <td>103.2</td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="3">经济性指标</td>
            <td>内部收益率(%)</td>
            <td>6.83</td>
            <td>612</td>
            <td>616</td>
            <td>246</td>
            <td></td>
          </tr>
          <tr>
            <td>经济净现值(亿元)</td>
            <td>60.29</td>
            <td>7.52</td>
            <td>10.03</td>
            <td>-154.40</td>
            <td></td>
          </tr>
          <tr>
            <td>提灌年耗电量(万MW-h)</td>
            <td>69938</td>
            <td>38044</td>
            <td>19340</td>
            <td>6075</td>
            <td></td>
          </tr>
          <tr>
            <td>比选结果</td>
            <td></td>
            <td>远期推荐方案</td>
            <td>近期推荐方案</td>
            <td>比较方案</td>
            <td>比较方案</td>
            <td>基于综合效益评估</td>
          </tr>
        </table>
      </div>

    </div>

  </div>
</template>

<script>

export default {
  name: "centerCard",
  data(){
    return{

    }
  },
  props: {
    title: {
      type: String
    },
  },
  mounted() {

  },
  destroyed() {

  },
  methods:{
    closeClick(){
      this.$emit('infoClose')
    },
  }
}
</script>


<style scoped>
/* 保持原有样式不变 */
.border {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(8, 18, 32, 0.96), rgba(13, 38, 50, 0.94));
  border-radius: 10px;
  margin-top: 0;
  padding: 18px;
  box-sizing: border-box;
  color: #eef7ff;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(99, 179, 237, 0.28);
  box-shadow: 0 18px 52px rgba(0, 0, 0, 0.42);
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}
.header-text {
  flex: 1;
}
.card-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

.orb-business-panel {
  width: min(1040px, calc(100vw - 230px));
  height: calc(100vh - 150px);
  position: absolute;
  left: 50%;
  top: 112px;
  transform: translateX(-54%);
  z-index: 9998;
}

.table{
  width: calc(100% - 20px);
  height: calc(100% - 80px);
  margin-top: 5px;
  margin-left: 10px;
  color: #eef7ff;
  font-size: 12px;
  border-collapse: collapse;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  overflow: hidden;
}
.table-content{
  width: 100%;
  height: calc(100% - 80px);
  overflow-y: auto;
}
.table td {
  border: 1px solid rgba(255, 255, 255, 0.04);
  padding: 8px 10px;
  text-align: center;
  vertical-align: middle;
  color: rgba(255, 255, 255, 0.72);
}
.table tr:first-child td {
  background-color: rgba(56, 189, 248, 0.1);
  font-weight: 600;
  color: #b8ecff;
  border-bottom: 1px solid rgba(56, 189, 248, 0.16);
}
.table tr:nth-child(odd) {
  background-color: rgba(255, 255, 255, 0.02);
}
.table tr:hover {
  background-color: rgba(56, 189, 248, 0.06);
}
.button1{
  height: 28px;
  width: auto;
  padding: 0 12px;
  border: 1px solid rgba(56, 189, 248, 0.32);
  background: rgba(56, 189, 248, 0.12);
  color: #b8ecff;
  font-size: 12px;
  font-weight: 500;
  border-radius: 7px;
  cursor: pointer;
  float: right;
  text-align: center;
  margin: 12px 0 0 0;
}
.button1:hover {
  background: rgba(56, 189, 248, 0.22);
}

.close {
  width: 30px;
  height: 30px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.72);
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, border-color 0.2s;
}
.close:hover {
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.28);
}
</style>
